import { z } from 'zod'

const rowSchema = z.object({
  name: z.string(),
  one_liner: z.string(),
  subtitle: z.string(),
  link: z.string(),
  video_url: z.string(),
  content: z.string(),
  image_urls: z.string(),
})

export const formSchema = z.object({
  rows: z.array(rowSchema).min(1),
})

export const DEFAULT_ROW: z.infer<typeof rowSchema> = {
  name: '',
  one_liner: '',
  subtitle: '',
  link: '',
  video_url: '',
  content: '',
  image_urls: '',
}

export const INPUT_CLASS =
  'h-9 border-0 bg-transparent focus-visible:ring-1 min-w-0'
